module.exports = "/assets/data/1761d535ad08e1f1f29b920c34c91b16-AB11.data.json";